import { useQuery } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";

export interface ListenerPhoneCallMetadata {
  status?: "processing" | "completed" | "failed";
  kind?: "call" | "voicemail";
  from?: string | null;
  duration_seconds?: number;
}

export interface ListenerPhoneCall {
  id: number;
  created_at: string;
  metadata: ListenerPhoneCallMetadata | null;
}

export const useListenerPhoneCalls = (agentId: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["listener-phone-calls", agentId],
    queryFn: async () => {
      const result = await ApiService.invoke<{ conversations: ListenerPhoneCall[] }>({
        resource: "conversations",
        action: "list",
        data: { agentIds: [agentId], conversationType: "recording", source: "phone", limit: 50 },
      });
      return result?.conversations ?? [];
    },
    enabled: !!agentId,
  });

  return { calls: data ?? [], isLoading, error };
};
